import {
  color,
  focusStyles,
  propertyColorStyles,
  radius,
  rem,
  spacing,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { PropertyColor } from '@thiememeulenhoff/types';
import { css, unsafeCSS } from 'lit';

const propertyColorCallback = (buttonColor: PropertyColor) => {
  const selector = unsafeCSS(`[color=${buttonColor}]`);

  return css`
    :host(${selector}) {
      input:checked + .slider {
        background-color: ${color(buttonColor)};
      }
    }

    :host(${selector}[checked]) .slider-thumb a-icon {
      color: ${color(buttonColor)};
      display: block;
    }
  `;
};

export const styles = [
  css`
    :host {
      --slider-size: ${rem(16)};
      --slider-padding: ${spacing(50)};

      display: inline-flex;
      justify-content: space-between;
    }

    .switch {
      align-items: center;
      block-size: calc(var(--slider-size) + var(--slider-padding) * 2);
      display: flex;
      inline-size: auto;
      position: relative;
    }

    .switch input {
      block-size: 100%;
      inline-size: 100%;
      opacity: 0;
      position: absolute;
    }

    ::slotted([slot='after']) {
      cursor: pointer;
      padding-inline-start: ${spacing(75)};
    }

    .slider {
      background-color: ${token('toggle-background-default')};
      border-radius: calc(var(--slider-size) + var(--slider-padding) * 2);
      color: ${token('toggle-foreground-default')};
      cursor: pointer;
      display: inline-block;
      inset: 0;
      min-block-size: calc(var(--slider-size) + var(--slider-padding) * 2);
      min-inline-size: calc(var(--slider-size) * 2 + var(--slider-padding) * 2);
      position: relative;
      transition: 0.4s;
    }

    .slider-thumb {
      align-items: center;
      background-color: ${token('background-secondary')};
      block-size: var(--slider-size);
      border-radius: ${radius('extra-large')};
      display: flex;
      font-size: ${rem(12)};
      inline-size: var(--slider-size);
      inset-block-end: var(--slider-padding);
      inset-inline-start: var(--slider-padding);
      justify-content: center;
      position: absolute;
      transition: 0.4s;

      a-icon {
        display: none;
      }
    }

    input:focus-visible + .slider {
      ${focusStyles};
    }

    :host([checked]) .slider-thumb {
      transform: translateX(var(--slider-size));
    }

    :host > label:hover {
      cursor: pointer;
    }

    :host([disabled]) {
      opacity: 0.5;
      pointer-events: none;
    }
  `,
  propertyColorStyles(propertyColorCallback),
];
